import { EvochaClient, type TokenPair } from "@evocha/api-client";

function resolveBaseUrl(): string {
  const env = import.meta.env as Record<string, string | undefined>;
  const configured = (env.VITE_API_URL ?? "").trim();
  if (configured) {
    return configured.replace(/\/+$/, "").replace(/\/v1$/, "");
  }
  return "http://localhost:8000";
}

export const API_BASE_URL = resolveBaseUrl();

const STORAGE_KEY = "evocha.agent.session";

function readStored(): Record<string, unknown> | null {
  try {
    const raw = localStorage.getItem(STORAGE_KEY);
    if (!raw) return null;
    return JSON.parse(raw) as Record<string, unknown>;
  } catch {
    return null;
  }
}

export const api = new EvochaClient({
  baseUrl: API_BASE_URL,
  timeoutMs: 25_000,
  getToken: () => {
    const stored = readStored();
    return typeof stored?.access_token === "string" ? stored.access_token : null;
  },
  getRefreshToken: () => {
    const stored = readStored();
    return typeof stored?.refresh_token === "string" ? stored.refresh_token : null;
  },
  onTokensRefreshed: (tokens: TokenPair) => {
    try {
      const stored = readStored() ?? {};
      localStorage.setItem(
        STORAGE_KEY,
        JSON.stringify({ ...stored, ...tokens }),
      );
    } catch {
      /* ignore */
    }
  },
  onUnauthorized: () => {
    try {
      localStorage.removeItem(STORAGE_KEY);
    } catch {
      /* ignore */
    }
  },
  headers: () => ({
    "X-Client": "evocha-web/1.0.0",
  }),
});
